import React, { forwardRef } from 'react';
import { Container } from './Container';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  containerSize?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  padding?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
  background?: 'default' | 'secondary' | 'tertiary' | 'transparent';
  border?: 'none' | 'top' | 'bottom' | 'both';
}

const paddingClasses = {
  none: '',
  sm: 'py-12 md:py-16',
  md: 'py-16 md:py-24',
  lg: 'py-24 md:py-32',
  xl: 'py-32 md:py-40',
};

const backgroundClasses = {
  default: 'bg-background',
  secondary: 'bg-background-secondary',
  tertiary: 'bg-background-tertiary',
  transparent: 'bg-transparent',
};

const borderClasses = {
  none: '',
  top: 'border-t border-border',
  bottom: 'border-b border-border',
  both: 'border-y border-border',
};

export const Section = forwardRef<HTMLElement, SectionProps>(({
  children,
  className = '',
  id,
  containerSize = 'xl',
  padding = 'lg',
  background = 'default',
  border = 'none',
}, ref) => {
  return (
    <section
      ref={ref}
      id={id}
      className={`
        ${paddingClasses[padding]}
        ${backgroundClasses[background]}
        ${borderClasses[border]}
        ${className}
      `}
    >
      <Container size={containerSize}>
        {children}
      </Container>
    </section>
  );
});

Section.displayName = 'Section';

export default Section;
